export default {
    init() {
        let upload = document.getElementById('sortpicture');
        if(upload) {
            let that = this;
            $(upload).change( function() {
                that.read_url(this);
            })
        }
    },
    read_url(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            
            reader.onload = function(e) {
              $('#img1 image').attr('xlink:href', e.target.result);
            }
            
            reader.readAsDataURL(input.files[0]); // convert to base64 string
          }
    }
}